/**
 * ALL CAPS — Shop the Caps discovery taxonomy.
 *
 * SINGLE SOURCE OF TRUTH for the two-level Shop the Caps filter (primary rail
 * + contextual secondary rail). Nothing else in the theme hardcodes category
 * labels or structure — ac-shop-grid.liquid only emits raw `ac-primary-*` /
 * ac-child-*-*` product tags, and ac-shop-grid.js reads this file to decide
 * what to render and how to filter.
 *
 * TO ADD A NEW CHILD CATEGORY (e.g. "Grandad" under Family):
 *   1. Add one entry to that primary's `children` array below.
 *   2. Tag the relevant Shopify product(s) with its `tag` value.
 *   That's it — no other file needs to change. A child only ever appears in
 *   the rail once a published product actually carries its tag.
 *
 * TO ADD A NEW PRIMARY CATEGORY:
 *   1. Add one entry to `primaries` below (key, label, tag, children: []).
 *   2. Tag products with the new `ac-primary-*` tag and whatever child tags
 *      apply.
 *   Same rule: it only appears once it has published products behind it.
 *
 * This taxonomy is intentionally separate from the older `allcaps-office /
 * -dating / -family / -chaos` tags, which still power the Find Your Cap quiz
 * (all-caps-quiz-data.js) and must not be repurposed or removed here.
 */
window.ACShopTaxonomy = {
  primaries: [
    {
      key: 'me',
      label: 'Me',
      tag: 'ac-primary-me',
      children: [
        { key: 'personality', label: 'Personality', tag: 'ac-child-me-personality' },
        { key: 'british-life', label: 'British Life', tag: 'ac-child-me-british-life' },
        { key: 'pub', label: 'Pub', tag: 'ac-child-me-pub' },
        { key: 'food', label: 'Food', tag: 'ac-child-me-food' },
        { key: 'hobbies', label: 'Hobbies', tag: 'ac-child-me-hobbies' },
        { key: 'social', label: 'Social', tag: 'ac-child-me-social' },
        { key: 'bad-decisions', label: 'Bad Decisions', tag: 'ac-child-me-bad-decisions' },
      ],
    },
    {
      key: 'family',
      label: 'Family',
      tag: 'ac-primary-family',
      children: [
        { key: 'mum', label: 'Mum', tag: 'ac-child-family-mum' },
        { key: 'dad', label: 'Dad', tag: 'ac-child-family-dad' },
        { key: 'new-mum', label: 'New Mum', tag: 'ac-child-family-new-mum' },
        { key: 'new-dad', label: 'New Dad', tag: 'ac-child-family-new-dad' },
        { key: 'auntie', label: 'Auntie', tag: 'ac-child-family-auntie' },
        { key: 'uncle', label: 'Uncle', tag: 'ac-child-family-uncle' },
        { key: 'sister', label: 'Sister', tag: 'ac-child-family-sister' },
        { key: 'brother', label: 'Brother', tag: 'ac-child-family-brother' },
        { key: 'grandma', label: 'Grandma', tag: 'ac-child-family-grandma' },
        { key: 'grandad', label: 'Grandad', tag: 'ac-child-family-grandad' },
        { key: 'in-laws', label: 'In-Laws', tag: 'ac-child-family-in-laws' },
        { key: 'group-chat', label: 'Family Group Chat', tag: 'ac-child-family-group-chat' },
      ],
    },
    {
      key: 'mates',
      label: 'Mates',
      tag: 'ac-primary-mates',
      children: [
        { key: 'best-mate', label: 'Best Mate', tag: 'ac-child-mates-best-mate' },
        { key: 'group-chat', label: 'Group Chat', tag: 'ac-child-mates-group-chat' },
        { key: 'bad-influence', label: 'Bad Influence', tag: 'ac-child-mates-bad-influence' },
        { key: 'going-out', label: 'Going Out', tag: 'ac-child-mates-going-out' },
        { key: 'gossip', label: 'Gossip', tag: 'ac-child-mates-gossip' },
        { key: 'pub', label: 'Pub', tag: 'ac-child-mates-pub' },
        { key: 'social-chaos', label: 'Social Chaos', tag: 'ac-child-mates-social-chaos' },
      ],
    },
    {
      key: 'love',
      label: 'Love',
      tag: 'ac-primary-love',
      children: [
        { key: 'single', label: 'Single', tag: 'ac-child-love-single' },
        { key: 'boyfriend', label: 'Boyfriend', tag: 'ac-child-love-boyfriend' },
        { key: 'girlfriend', label: 'Girlfriend', tag: 'ac-child-love-girlfriend' },
        { key: 'husband', label: 'Husband', tag: 'ac-child-love-husband' },
        { key: 'wife', label: 'Wife', tag: 'ac-child-love-wife' },
        { key: 'situationship', label: 'Situationship', tag: 'ac-child-love-situationship' },
        { key: 'exes', label: 'Exes', tag: 'ac-child-love-exes' },
        { key: 'divorced', label: 'Divorced', tag: 'ac-child-love-divorced' },
      ],
    },
    {
      key: 'work',
      label: 'Work',
      tag: 'ac-primary-work',
      children: [
        { key: 'colleague', label: 'Colleague', tag: 'ac-child-work-colleague' },
        { key: 'boss', label: 'Boss', tag: 'ac-child-work-boss' },
        { key: 'hr', label: 'HR', tag: 'ac-child-work-hr' },
        { key: 'wfh', label: 'WFH', tag: 'ac-child-work-wfh' },
        { key: 'emails', label: 'Emails', tag: 'ac-child-work-emails' },
        { key: 'meetings', label: 'Meetings', tag: 'ac-child-work-meetings' },
        { key: 'networking', label: 'Networking', tag: 'ac-child-work-networking' },
        { key: 'leaving', label: 'Leaving', tag: 'ac-child-work-leaving' },
        { key: 'teacher', label: 'Teacher', tag: 'ac-child-work-teacher' },
        { key: 'nurse', label: 'Nurse', tag: 'ac-child-work-nurse' },
        { key: 'hospitality', label: 'Hospitality', tag: 'ac-child-work-hospitality' },
        { key: 'retail', label: 'Retail', tag: 'ac-child-work-retail' },
        { key: 'freelancer', label: 'Freelancer', tag: 'ac-child-work-freelancer' },
      ],
    },
    {
      key: 'pets',
      label: 'Pets',
      tag: 'ac-primary-pets',
      children: [
        { key: 'dog', label: 'Dog', tag: 'ac-child-pets-dog' },
        { key: 'cat', label: 'Cat', tag: 'ac-child-pets-cat' },
        { key: 'horse', label: 'Horse', tag: 'ac-child-pets-horse' },
        { key: 'pet-people', label: 'Pet People', tag: 'ac-child-pets-pet-people' },
      ],
    },
    {
      key: 'occasions',
      label: 'Occasions',
      tag: 'ac-primary-occasions',
      children: [
        { key: 'birthday', label: 'Birthday', tag: 'ac-child-occasions-birthday' },
        { key: 'secret-santa', label: 'Secret Santa', tag: 'ac-child-occasions-secret-santa' },
        { key: 'christmas', label: 'Christmas', tag: 'ac-child-occasions-christmas' },
        { key: 'mothers-day', label: "Mother's Day", tag: 'ac-child-occasions-mothers-day' },
        { key: 'fathers-day', label: "Father's Day", tag: 'ac-child-occasions-fathers-day' },
        { key: 'leaving', label: 'Leaving', tag: 'ac-child-occasions-leaving' },
        { key: 'hen', label: 'Hen', tag: 'ac-child-occasions-hen' },
        { key: 'new-baby', label: 'New Baby', tag: 'ac-child-occasions-new-baby' },
      ],
    },
  ],
};
